import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { IsFullyAuthenticatedGuard } from './guards/is-fully-authenticated/is-fully-authenticated.guard';
import { AdminComponent } from './components/admin/admin.component';
import { AdminGuard as IsAdminGuard } from './guards/is-admin/is-admin.guard';
import { RegisterComponent } from './components/register/register.component';
import { EmailVerificationCodeComponent } from './components/email-verification-code/email-verification-code.component';
import { IsNotFullyAuthenticatedGuard } from './guards/is-not-fully-authenticated/is-not-fully-authenticated.guard';
import { AlreadyAuthenticatedGuard } from './guards/already-authenticated/already-authenticated.guard';

// TODO docker for FE???

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/home',
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AlreadyAuthenticatedGuard],
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [AlreadyAuthenticatedGuard],
  },
  {
    path: 'verify-email',
    component: EmailVerificationCodeComponent,
    canActivate: [IsNotFullyAuthenticatedGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [IsFullyAuthenticatedGuard],
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [IsAdminGuard],
  },
];
